import { Component, OnInit } from '@angular/core';
import { Osoba } from './osoba';
import { BaseDataService, ModalService, NotificationService, YtKontrolaJmbg } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osoba-update',
  templateUrl: './osoba-update.component.html'
})
export class OsobaUpdateComponent
 extends BaseUpdateComponent<Osoba>
 implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Ime", Validators.required, "required", "OSOBA.IME.VALIDATION.REQUIRED");
    this.addValidatorToFc("Ime", Validators.maxLength(50), 'maxlength', "OSOBA.IME.VALIDATION.MAXLENGTH");
    this.addValidatorToFc("Prezime", Validators.required, "required", "OSOBA.PREZIME.VALIDATION.REQUIRED");
    this.addValidatorToFc("Prezime", Validators.maxLength(50), 'maxlength', "OSOBA.PREZIME.VALIDATION.MAXLENGTH");
    this.addValidatorToFc("Jmbg", Validators.maxLength(13), 'maxlength', "OSOBA.JMBG.VALIDATION.MAXLENGTH");
    this.addValidatorToFc("Jmbg",YtKontrolaJmbg, 'jmbgControl', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL11');
    this.addValidatorToFc("ImeOca", Validators.maxLength(30), 'maxlength', 'OSOBA.IMEOCA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Devojacko", Validators.maxLength(30), 'maxlength', 'OSOBA.DEVOJACKO.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("PolID", Validators.required, "required", "OSOBA.POL.VALIDATION.REQUIRED");
    // this.addValidatorToFc("MestoRodjID", Validators.required, "required", "");
    // this.addValidatorToFc("BracniStatusID", Validators.required, "required", "");
    // this.addValidatorToFc("BrojLK", Validators.maxLength(10), 'maxlength', '');
    // this.addValidatorToFc("LboBroj", Validators.maxLength(11), 'maxlength', '');
    // this.addValidatorToFc("NacijaID", Validators.required, "required", "");
    // this.addValidatorToFc("VeroispovestID", Validators.required, "required", "");
    // this.addValidatorToFc("VerskiPraznikID", Validators.required, "required", "");
    // this.addValidatorToFc("FirmaID", Validators.required, "required", "");   
  }

}
